// Zamiast jQuery $(document).ready(function(){})
function ready(fn) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

function addClass(el, className) {
    if (el === null) return;

    if (el.classList)
        el.classList.add(className);
    else{
        if (typeof el.className === 'object') { // obsługa svgów w IE
            el.className.baseVal += ' ' + className;
        } else {
            el.className += ' ' + className;
        }
    }
}

function removeClass(el, className) {
    if (el === null) return;

    if (el.classList)
        el.classList.remove(className);
    else {
        var regex = new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi');

        if (typeof el.className === 'object') { // obsługa svgów w IE
            el.className.baseVal = el.className.baseVal.replace(regex, ' ');
        } else {
            el.className = el.className.replace(regex, ' ');
        }
    }
}

function hasClass(el, className) {
    if (el.classList)
        return el.classList.contains(className);
    else{
        var classes = el.className;

        if (typeof el.className === 'object') { // obsługa svgów w IE
            classes = el.className.baseVal;
        }

        return new RegExp('(^| )' + className + '( |$)', 'gi').test(classes);
    }
}

function toggleClass(el, className) {
    if (el.classList) {
        el.classList.toggle(className);
    } else {
        var classes = el.className.split(' ');
        var existingIndex = classes.indexOf(className);

        if (existingIndex >= 0)
            classes.splice(existingIndex, 1);
        else
            classes.push(className);

        el.className = classes.join(' ');
    }
}

function index(el) {
    if (!el) return -1;
    var i = 0;
    do {
        if (el.nodeType === 1) i++;
        el = el.previousSibling;
    } while (el)
    return i;
}

function throttle(callback, limit) {

    var wait = false;
    return function () {
        if (!wait) {

            callback.apply(null, arguments);
            wait = true;
            setTimeout(function () {
                wait = false;
            }, limit);
        }
    }
}

// Polyfill for rAF
window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
})();

function rafThrottle(fn) {
    var busy = false;

    return function () {
        if (busy) return;
        busy = true;
        fn.apply(this, arguments);

        requestAnimFrame(function () {
            busy = false;
        });
    };
}

// polyfill dla IE, które nie obsługuje forEach dla NodeList (np. z querySelectorAll)
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

function isIE() {
    return !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
}

function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function isFirefox() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1
}

function isIntersectionObserverEnabled() {
    return ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype);
}

// Polyfill dla IE dla metody matches
if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;

// Polyfill dla IE dla metody closest
if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}


function isElementInViewport(el, threshold) {
    threshold = (typeof threshold !== 'undefined') ?  threshold : 0;

    var rect = el.getBoundingClientRect(),
        height = window.innerHeight || document.documentElement.clientHeight;

    return (
        (rect.top <= height + threshold && rect.bottom >= height) ||
        (rect.bottom <= height && rect.bottom + threshold > 0)
    );
}

/**
 * zwraca obiekt w formacie key1=val1&key2=val2
 */
function encodeObject(object) {
    var encodedString = '';
    for (var prop in object) {
        if (object.hasOwnProperty(prop)) {
            if (encodedString.length > 0) {
                encodedString += '&';
            }
            encodedString += encodeURI(prop + '=' + object[prop]);
        }
    }
    return encodedString;
}

/**
 * Sprawdza czy urządzanie ma dotykowy ekran
 * @returns true|false
 */
function isTouchDevice() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function(query) {
        return window.matchMedia(query).matches;
    }

    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}

/**
 * Serializuje obiekt do stringa
 * @param obj
 * @returns {string}
 */
function serialize(obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}